import script from "./tutorial-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./tutorial-menu.vue?vue&type=script&setup=true&lang=ts"

import "./tutorial-menu.vue?vue&type=style&index=0&id=cad5f3d4&lang=scss"

const __exports__ = script;

export default __exports__